import React from "react";
import "./WhatsAppButton.css";

function WhatsAppButton() {
  const phoneNumber = "96170210576";

  const message = encodeURIComponent(
    "Hello, I would like to inquire about your photography services."
  );

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${phoneNumber}?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <button
      type="button"
      className="whatsapp-floating"
      onClick={handleWhatsApp}
      aria-label="Contact us on WhatsApp"
    >
      <span className="whatsapp-icon">
        <svg
          viewBox="0 0 32 32"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M19.11 17.25c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.13-.42-2.15-1.34-.79-.7-1.33-1.57-1.49-1.84-.16-.27-.02-.42.12-.56.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.26s.98 2.62 1.11 2.8c.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.56.58.66.21 1.26.18 1.73.11.53-.08 1.6-.66 1.83-1.3.23-.64.23-1.18.16-1.3-.07-.11-.25-.18-.52-.32z"
          />
          <path
            fill="currentColor"
            d="M16.02 3.2c-7.08 0-12.84 5.75-12.84 12.82 0 2.26.59 4.46 1.72 6.4L3.1 28.8l6.53-1.71a12.8 12.8 0 0 0 6.38 1.69h.01c7.07 0 12.82-5.75 12.82-12.82S23.09 3.2 16.02 3.2zm0 23.47h-.01a10.62 10.62 0 0 1-5.41-1.48l-.39-.23-3.88 1.02 1.04-3.78-.25-.39a10.62 10.62 0 1 1 8.9 4.86z"
          />
        </svg>
      </span>

    
    </button>
  );
}

export default WhatsAppButton;